// extracted by mini-css-extract-plugin
export default {"block__title":"FooterSection_block__title__WMo8v","block__list":"FooterSection_block__list__2skqr","block__link":"FooterSection_block__link__zNm6U"};